import {
  Typography,
  Box,
} from '@mui/material';


const Article = () => {
  return (
    <article itemScope itemType="https://schema.org/Article">
      <section id="origin-spongebob">
        <Typography variant="h5" gutterBottom>
          SpongeBob &amp; Jacques Cousteau Satire
        </Typography>
        <p>If you’ve ever heard the phrase <em>“Two hours later…”</em> in a funny French accent, you’re seeing a format popularized by <strong>SpongeBob SquarePants</strong>. The show’s memorable “time cards” arrived in the late 1990s, delivered by an exaggerated French narrator. This voice was a playful homage to renowned ocean explorer <strong>Jacques Cousteau</strong>, whose classic documentaries featured calm, French-accented narration about marine life. SpongeBob’s creators leaned into that tone and pushed it into satire—familiar, affectionate, and gloriously over-the-top.</p>
        <p>Phrases like <em>“A few moments later”</em>, <em>“Three days later”</em>, and <em>“Many months later”</em> became part of the show’s comedic DNA. Rather than only displaying text, the French narrator’s delivery turned simple time jumps into punchlines. This blend of <strong>satire, absurd humor, and sharp timing</strong> made the time cards instantly recognizable and endlessly quotable.</p>
      </section>

      <section id="meme-culture">
        <Typography variant="h5" gutterBottom>
          From TV Gag to Meme Culture
        </Typography>
        <p>Over time, the bit escaped television and found a second life online. YouTube creators, TikTok editors, and vloggers embraced the “funny French accent” as a universal signal for <strong>time passing with comedic effect</strong>. Today, when you hear <em>“Two hours later…”</em>, you anticipate the payoff—something funny, awkward, or unexpected. The gag now sits alongside the record scratch and laugh track as one of digital culture’s most recognizable audio cues.</p>
      </section>

      <section id="create-custom">
        <Typography variant="h5" gutterBottom>
          Create Custom Time Cards for Your Videos
        </Typography>
        <p>When we noticed creators procuded their own transitions and there was no <em>easy</em> way of creating these <strong>custom time cards and narrator phrases</strong>, we decided to create this Free!! tool.</p>
        <p><em>Mr. Later</em> provides exactly what you need: easily generate SpongeBob-inspired, French-accented transitions; customize the wording; and drop them straight into your edits. Whether you need a dramatic <em>“Ten years later”</em> or a snappy <em>“Thirty seconds later”</em>, these phrases add humor, personality, and a professional touch that boosts engagement.</p>
        <p>Also, feel free to use below image of <em>Mr. Later</em> in your content. If you enjoy using this tool, please give us a shoutout in your content!</p>
        <p><a className="cta" href="#top" rel="noopener">Generate Your Custom Time Phrase</a></p>
        <Box
          component="img"
          src="static/images/mrlater.png"
          alt="Mr. Later"
          sx={{
            width: '100%',
          }}
        />
      </section>
    </article>
  );
};

export default Article;